import detail from './detail.js';

export default {
  detail
}
